import React, { ReactNode, useEffect, useState } from 'react'
import LabelNumber from '../../../styled-components/LabelNumber';
import LabelText from '../../../ui/LabelText';
import { useNavigate } from 'react-router-dom';
import { useNewPlayerShortlistContext } from '../../../contexts/NewPlayerShortlistContext';
import { useClubSearch } from '../../../contexts/ClubSearchContext';
import apiUrls, { BASE_URL } from '../../../config/apiUrls';
import { usePlayerSearch } from '../../../contexts/SearchPlayersContext';
import profile from "../../../assets/icons/Profile.png";
import search from "../../../assets/icons/Spyglass.png";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import ToggleButton from '../../../ui/ToggleButton/ToggleButton';
import SecondaryButton from '../../../ui/SecondaryButton';
import styled from "styled-components";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CustomizedTooltips from '../../../ui/Tooltip';
import { PlayerAvatar } from '../../../styled-components/PlayerCard.Styles';
import PWNotification from '../../PWNotification';
import { IFinancialPlayerTransfer, IseasonData } from '../../../types/IClubDetail';
import noImageFlag from "../../../assets/icons/noImageFlag.svg";
import noImageClub from "../../../assets/icons/noImageClub.svg";
import noImagePlayer from "../../../assets/icons/noImagePlayer.svg";
import OutIcon from "../../../assets/icons/OutIcon.png";
import InIcon from "../../../assets/icons/InIcon.png";
import { useTheme } from '../../../contexts/ThemeContext';
import U16 from "../../../assets/extraclubicons/U16.svg";
import U17 from "../../../assets/extraclubicons/U17.svg";
import U18 from "../../../assets/extraclubicons/U18.svg";
import U19 from "../../../assets/extraclubicons/U19.svg";
import U20 from "../../../assets/extraclubicons/U20.svg";
import U21 from "../../../assets/extraclubicons/U21.svg";
import IApiResponse from '../../../types/IApiResponse';
import { useLoading } from '../../../contexts/LoadingContext';
import handleApiResponse from '../../../utils/handleApiResponse';
import { fetchData, postData } from '../../../services/api';
import CustomDropdown from '../../../ui/CustomDropdown';
import { ModuleSpinner } from '../../../ui/LoadingSpinner/ModuleSpinner';
import { addUpdateSortListData } from '../../PlayerComparison/addOrUpdateSortList';
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import { useAuth } from '../../../contexts/AuthContext';
import '../../PlayerComparison/playercomparison.css';



const StyledTableCell = styled(TableCell)(({ theme }) => ({
    "& .clubLogoSVG": {
      filter:
        theme.mode === "light"
          ? "invert(46%) sepia(100%) saturate(1989%) hue-rotate(1deg) brightness(104%) contrast(106%)"
          : "invert(59%) sepia(84%) saturate(2319%) hue-rotate(127deg) brightness(100%) contrast(101%)",
    },
    [`&.${tableCellClasses.head}`]: {
      fontSize: 16,
      color: theme.NumberColor,
      fontWeight: 500,
      fontFamily: "Aeonik",
      borderBottom: `1px solid ${theme.playerDataBorder}`,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      color: theme.playerDataValueColor,
      fontFamily: "DM Mono",
      border: 0,
      fontWeight: 500,
      textTransform: "uppercase",
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(even)": {
      backgroundColor: theme.playerCardBackground,
      border: 0,
    },
  }));

  const extraClubArray = [
    { id: "U16", img: U16 },
    { id: "U17", img: U17 },
    { id: "U18", img: U18 },
    { id: "U19", img: U19 },
    { id: "U20", img: U20 },
    { id: "U21", img: U21 },
  ];

interface ITransferHistoryProps{
    teamId : string;
    isFullView : boolean
}

const TransferHistory : React.FC<ITransferHistoryProps> = ({teamId , isFullView}) => {

    const navigate = useNavigate();
    const { theme } = useTheme();
    const { userData } = useAuth();
    const { reset, setOriginPage } = usePlayerSearch();
    const { startLoading, stopLoading , loading } = useLoading();
    const [addedPlayerShortList, setAddedPlayerShortList] = useState<boolean>(false);
    const { newlyAddedPlayerCount, setNewlyAddedPlayerCount } = useNewPlayerShortlistContext();
    const [selectedPlayerId, setSelectedPlayerId] = useState<number>();
    const { addedPlayers, setAddedPlayers } = useClubSearch();
    const [menuOpenPlayerId, setMenuOpenPlayerId] = useState<number | null>(null);
    const [hoveredPlayerId, setHoveredPlayerId] = useState<number | null>(null);
    const [displayCustomNotification, setDisplayCustomNotification] = useState<boolean>(false);
    const [customNotificationContent, setCustomNotificationContent] = useState<ReactNode>(null);
    const [selectedLabel, setSelectedLabel] = useState<string>("all");
    const [filterTransferData, setfilterTransferData] = useState<IFinancialPlayerTransfer[]>([]);
    const [transferData, setPlayerTransferData] = useState<IFinancialPlayerTransfer[]>([]);
    const [seasonData, setSeasonData] = useState<any[]>([]);
    const [seasonLabel, setSeasonLabel] = useState("");
    const [seasonId, setSeasonId] = useState<number>();
    const [tranferseasonId, setTranferSeasonId] = useState<number>();


    
    const financialPlayerTranferData = selectedLabel === "in" || selectedLabel === "out" ? filterTransferData : transferData;
    const displayData = isFullView ? financialPlayerTranferData : financialPlayerTranferData.slice(0, 10);
        
    
    const isImageUrl = (url: string) => {
        return url.match(/\.(jpeg|jpg|gif|png|svg)$/) !== null;
    };
    
    const specificHeaders = ["Player", "Nationality", "In / out", "From / to", "Date", "Transfer fee"];

    const headers = specificHeaders;

    // useEffect(() => {
    //     setSeasonLbl(seasonLabel);
    //   }, [seasonLabel]);
    
      const toggleLabel = [
        { key: "all", value: "  All  " },
        { key: "in", value: "  In  " },
        { key: "out", value: "  Out   " },
      ];

      useEffect(() => {
        const fetchSeasonData = async () => {
          const response: IApiResponse<IseasonData> = await fetchData(`${apiUrls["GetAllCompetitionSeasonsByTeamId"]}?TeamId=${teamId}`);
          handleApiResponse(
            response,
            (teamsData) => {
              setSeasonData(teamsData.seasonData);
              setSeasonId(teamsData.previousSeasonId);
              const matchedSeason = teamsData.seasonData.find((season) => season.value === teamsData.previousSeasonId);
              if (matchedSeason) {
                setSeasonLabel(matchedSeason.label);
              }
            },
            (error) => {
              console.error("Error fetching club card Data:", error);
            }
          );
        };
        fetchSeasonData();
      }, [teamId]);


      useEffect(() => {
        if (tranferseasonId) {
          fetchFinancialPlayerTransfer(tranferseasonId);
        }
      }, [tranferseasonId]);


    const handleTransferSeasonChange = (seasonId: string) => {
      setTranferSeasonId(Number(seasonId));
    };

      const fetchFinancialPlayerTransfer = async ( seasonId? : number) => {
        try {
          startLoading();
          const ApiRequestData = {
            teamId: Number(teamId),
            transfertype: "all",
            seasonId: seasonId,
          };
          const response: IApiResponse<IFinancialPlayerTransfer[]> = await postData(apiUrls.GetTeamFinancialPlayerTransfers, ApiRequestData);
          handleApiResponse(
            response,
            (playerData) => {
              stopLoading();
              setPlayerTransferData(playerData);
               if (selectedLabel === "in") {
                  const filteredData = playerData.filter((player) => player.transferType === "In");
                  setfilterTransferData(filteredData);
                } else if (selectedLabel === "out") {
                  const filteredData = playerData.filter((player) => player.transferType === "Out");
                  setfilterTransferData(filteredData);
                } else {
                  setfilterTransferData(transferData); // "all" selected
                }
            },
            (error) => {
              console.error("Error fetching PlayerCard Data:", error);
            }
          );
        } catch (error) {
          stopLoading();
          console.error("Error fetching player card data:", error);
        }
      };

        useEffect(() => {
          if (Number(teamId)) {
            fetchFinancialPlayerTransfer();
          }
        }, [Number(teamId)]);

      const handleToggleChange = (SelectedTab: any) => {
        setSelectedLabel(SelectedTab.key);
        if (SelectedTab.key === "in") {
          const filteredData = transferData.filter((player) => player.transferType === "In");
          setfilterTransferData(filteredData);
        } else if (SelectedTab.key === "out") {
          const filteredData = transferData.filter((player) => player.transferType === "Out");
          setfilterTransferData(filteredData);
        } else {
          setfilterTransferData(transferData); // "all" selected
        }
      };
      useEffect(() => {
        if (transferData?.length) {
          const initialStatus = transferData.reduce((acc: any, player) => {
            acc[player.playerId] = player.isPlayerInShortlist || false; // Use existing value or default to false
            return acc;
          }, {});
          setAddedPlayers(initialStatus);
        }
      }, [transferData]);

    const handleAddPlayer = (playerId: number) => {
        setNewlyAddedPlayerCount((prev) => prev + 1);
        setSelectedPlayerId(playerId);
        setAddedPlayers((prevAddedPlayers: any) => ({
          ...prevAddedPlayers,
          [playerId]: !prevAddedPlayers[playerId], // Toggle the boolean value
        }));
    }

    const handleMenuOpen = (playerId: number) => {
        setMenuOpenPlayerId((prevId) => {
          if (prevId === playerId) {
            setHoveredPlayerId(null);
            return null;
          }
          setHoveredPlayerId(playerId);
          return playerId;
        });
      };

    const handleSimilarSearch = (playerId: number) => {
        reset();
        window.open(`${BASE_URL}/player/${playerId}?tab=SimilarPlayers`, "_blank");
        setOriginPage("Similarplayers Tab");
      };


    const renderMenuCard = (playerId: number) => {
        return (
          <>
            <div className="menu-card-container">
              <div className="menu-list-container">
                <LabelNumber className="attack-defense-data">OPTIONS</LabelNumber>
              </div>
              <div
                className="menu-list-container"
                onClick={() => {
                  navigate(`/player/${playerId}`);
                }}
              >
                <img src={profile} height={24} width={24} />
                <LabelText className="menu-list">Player Profile</LabelText>
              </div>
              <div
                className="menu-list-container"
                onClick={() => {
                  handleSimilarSearch(playerId);
                }}
              >
                <img src={search} height={24} width={24} />
                <LabelText className="menu-list">Search for similar</LabelText>
              </div>
              <div className={`menu-list-container ${addedPlayers[playerId] ? "added" : ""}`}>
                <BookmarkBorderIcon />
                <LabelText
                  className="menu-list"
                  onClick={() => handleAddPlayer(playerId)}
                  style={{ color: addedPlayers[playerId] ? "white" : "" }}
                >
                  {addedPlayers[playerId] ? "Added to shortlist" : "Add to shortlist"}
                </LabelText>
              </div>
            </div>
          </>
        );
      };

      const handleRowHover = (playerId: number) => {
        setHoveredPlayerId(playerId);
      };

      const handleRowLeave = () => {
        setHoveredPlayerId(null);
        setMenuOpenPlayerId(null);
      };

      const handlePlayerComparision = () => {
        localStorage.removeItem("removedIds");
        const playerIds = financialPlayerTranferData.map((player) => player.playerId);
        navigate(`/playercomparison`, { state: { playerIds, isFromSortList: false, benchMarkPlayerId: null } });
      };


      const handleActions = () => {
        setAddedPlayers((prevAddedPlayers: any) => {
          const isCurrentlyInShortlist = prevAddedPlayers[selectedPlayerId!];
          const updatedAddedPlayers = {
            ...prevAddedPlayers,
            [selectedPlayerId!]: !isCurrentlyInShortlist,
          };
          addUpdateSortListData(
            userData,
            [selectedPlayerId!],
            startLoading,
            stopLoading,
            setDisplayCustomNotification,
            setCustomNotificationContent,
            false,
            navigate
          );
    
          return updatedAddedPlayers;
        });
      };
    
      useEffect(() => {
        setCustomNotificationContent(
          <div className="notification">
            <p className="sortlist-notofication-content">
              <BookmarkBorderOutlinedIcon className="icon" />
              <LabelText className="squad-chart-tooltip notification-content">
                {addedPlayerShortList ? "Player added to your shortlist " : "Player removed from your shortlist"}
              </LabelText>
              {addedPlayerShortList ? (
                <LabelText
                  className="player-given-name notification-content"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/shortlists")}
                >
                  View shortlist
                </LabelText>
              ) : (
                <LabelText className="player-given-name notification-content" style={{ cursor: "pointer" }} onClick={() => handleActions()}>
                  Undo
                </LabelText>
              )}
            </p>
          </div>
        );
      }, [addedPlayerShortList, addedPlayers]);
    

      
  return (
    <>
    <div className="table-header-content">
        {isFullView ? (
            <div className="custom-dropdown">
            <CustomDropdown placeholder="SEASON"  isDisplaySearchInput={false} options={seasonData} onChange={handleTransferSeasonChange} deafaultSelected={seasonLabel} Id={Number(teamId)}/>
          </div>
        ):(
            <LabelText className="player-detail-given-name">Transfers & 1st team promotions </LabelText>

        )}
      <div style={{display:'flex',gap:"8px"}}>
      <ToggleButton labels={toggleLabel || []} defaultLabelKey={selectedLabel!} onChange={handleToggleChange} />
      <SecondaryButton
        iconType="playercomparison"
        label="Comparison tools"
        className="comparision-tools-btn"
        onClick={handlePlayerComparision}
      /></div>
    </div>
    <div className={isFullView ? 'table-scroll' : ''}>
    <TableContainer
      component={Paper}
      style={{ backgroundColor: "transparent", boxShadow: "none", overflow: "hidden",marginBottom:'24px',marginTop:'25px' }}
      className={isFullView ? 'custom-table-test' : ''}
    >
      <Table sx={{ minWidth: 700 }} aria-label="customized table" className='custom-table'>
        <TableHead className={isFullView ? 'custom-table-sticky' : ''}>
          <TableRow>
            {headers?.map((header) => (
              <StyledTableCell key={header}>{header}</StyledTableCell>
            ))}
            <StyledTableCell className="right-transfer-table-menu-main"></StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={{whiteSpace:'nowrap'}}>
          {displayData?.map((row, rowIndex) => (
            <StyledTableRow
              key={rowIndex}
              className="player-row"
              // onMouseEnter={() => handleRowHover(row.playerId)}
              // onMouseLeave={handleRowLeave}
            >
              <StyledTableCell key={rowIndex}>
                <div className="tabel-cell-contanier">
                  <PlayerAvatar
                    className="table-avatar"
                    backgroundImage={row?.playerImageURL !== null ? row?.playerImageURL : noImagePlayer}
                  />
                  <div className="table-player-name">
                    <LabelText
                      className="player-search-text clickable"
                      onClick={() => {
                        navigate(`/player/${row?.playerId}`);
                      }}
                    >
                      {row.playerName}
                    </LabelText>
                    <div>
                      <LabelNumber className="attack-defense-data">{row.playingPosition}</LabelNumber>
                    </div>
                  </div>
                </div>
              </StyledTableCell>
              <StyledTableCell>
                <div className="tabel-cell-contanier">
                  <CustomizedTooltips title={row.nationalityCountry}>
                    <img
                      src={row.nationalityCountryCode ? `/assets/country_flags/${row.nationalityCountryCode}.svg` : `${noImageFlag}`}
                      width={32}
                      height={32}
                      style={{ borderRadius: "50%", border: "1px solid", objectFit: "cover" }}
                    />
                  </CustomizedTooltips>
                </div>
              </StyledTableCell>
              <StyledTableCell>
                <div className="tabel-cell-contanier icon-cell">
                  <LabelNumber className="table-age-text">{row.transferType}</LabelNumber>
                  {row.transferType === "In" ? (
                    <img src={InIcon} className="secondary-cta-icon" alt="teamIcon" />
                  ) : (
                    <img src={OutIcon} className="secondary-cta-icon" alt="teamIcon" />
                  )}
                </div>
              </StyledTableCell>
              <StyledTableCell>
                <div className="tabel-cell-contanier">
                  {row.transferFeeText === "Retired" || row.transferFeeText === "Free agent" ? (
                    <></>
                  ) : (
                    <>
                      <CustomizedTooltips title={row.transferType === "In" ? row.fromTeamName : row.toTeamName}>
                        <img
                          src={
                            row.transferType === "In"
                              ? isImageUrl(row.fromTeamImageURL)
                                ? row.fromTeamImageURL
                                : extraClubArray.find((club) => String(row.fromTeamName).includes(club.id))?.img || noImageClub
                              : isImageUrl(row.toTeamImageURL)
                              ? row.toTeamImageURL
                              : extraClubArray.find((club) => String(row.toTeamName).includes(club.id))?.img || noImageClub
                          }
                          alt="Club Image"
                          width={32}
                          height={32}
                          // style={{ borderRadius: '50%', border: '1px solid', objectFit: 'cover' }}
                          onClick={() => {
                            navigate(`/club/${row.transferType === "In" ? row.fromTeamId : row.toTeamId}`);
                          }}
                          style={{ cursor: "pointer" }}
                          className={
                            row.transferType === "In"
                              ? !isImageUrl(row.fromTeamImageURL) &&
                                extraClubArray.find((club) => String(row.fromTeamName).includes(club.id))?.img
                                ? "clubLogoSVG"
                                : ""
                              : !isImageUrl(row.toTeamImageURL) &&
                                extraClubArray.find((club) => String(row.toTeamName).includes(club.id))?.img
                              ? "clubLogoSVG"
                              : ""
                          }
                        />
                      </CustomizedTooltips>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "5px" }}>
                        <LabelNumber className="attack-defense-data">{row.transferType === "In" ? "From" : "TO"}</LabelNumber>
                        <LabelNumber
                          className="table-age-text clickable"
                          onClick={() => {
                            navigate(`/club/${row.transferType === "In" ? row.fromTeamId : row.toTeamId}`);
                          }}
                        >
                          {row.transferType === "In" ? row.fromTeamName : row.toTeamName}
                        </LabelNumber>
                      </div>
                    </>
                  )}
                </div>
              </StyledTableCell>
              <StyledTableCell>
                <div>
                  <LabelNumber className="attack-defense-data">{row.isFutureTransfer ? `Upcoming` : ""}</LabelNumber>
                </div>
                <LabelNumber
                  className="table-age-text"
                  style={{ color: row.isFutureTransfer ? `${theme.tableDateColor}` : `${theme.playerColor}` }}
                >
                  {new Date(row.transferDate)
                    .toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })
                    .replace(/ (\d{4})$/, ", $1")}
                </LabelNumber>
              </StyledTableCell>
              <StyledTableCell>
                <LabelText className="player-search-text">
                  {row.showCurrencySymbol ? `€${row.transferFeeText}` : row.transferFeeText}
                </LabelText>
                <div>
                  <LabelNumber className="attack-defense-data">{row.showLoanFee ? `€${row.transferFeeValueInText}` : ""}</LabelNumber>
                </div>
              </StyledTableCell>
              {hoveredPlayerId === row.playerId && (
                <StyledTableCell className="right-transfer-table-menu-main">
                  <div className="benchmark-row">
                    <SecondaryButton iconType="menu" className="column-expand-btn" onClick={() => handleMenuOpen(row?.playerId!)} />
                    {menuOpenPlayerId === row?.playerId && <>{renderMenuCard(row?.playerId)}</>}
                  </div>
                </StyledTableCell>
              )}
              <StyledTableCell></StyledTableCell>

            </StyledTableRow>
            
          ))}
        </TableBody>
      </Table>
      {displayCustomNotification && (
        <PWNotification
          message={customNotificationContent}
          setIsNotification={() => setDisplayCustomNotification(false)}
          isDisplayCloseIcon={true}
          className="player-filter-notification add-similar-notification"
        />
      )}
      {/* <div className="table-btn-container">
        <SecondaryButton
          onClick={handleViewAll}
          label={showAll ? "Show less" : "Show full transfer breakdown"}
          iconType={showAll ? "keyboardarrowup" : "keyboardarrowdown"}
        />
      </div> */}
        {loading && <ModuleSpinner />}
        {displayCustomNotification && (
            <PWNotification
              message={customNotificationContent}
              setIsNotification={() => setDisplayCustomNotification(false)}
              isDisplayCloseIcon={true}
              className="player-filter-notification add-similar-notification"
            />
          )}
    </TableContainer>
    </div>
  </>
  )
}

export default TransferHistory;